var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FB6340",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360,735 C1285,735 1245,805 1265,860 L1085,1040 C1070,1035 1050,1035 1035,1040 L905,910 C925,855 885,785 810,785 C740,785 695,855 715,910 L485,1135 C430,1120 360,1160 360,1235 C360,1290 405,1335 460,1335 C530,1335 575,1265 555,1210 L780,980 C795,985 815,985 830,980 L960,1110 C945,1160 985,1235 1060,1235 C1135,1235 1175,1165 1155,1110 L1335,930 C1390,945 1460,905 1460,835 C1460,780 1415,735 1360,735 M1060,785 L1105,680 L1210,635 L1105,590 L1060,485 L1015,590 L910,635 L1015,680 L1060,785 M485,885 L510,785 L610,760 L510,735 L485,635 L460,735 L360,760 L460,785 L485,885 Z",
    id: "Shape",
    fill: "#FB6340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbody);
export default __webpack_public_path__ + "static/media/inbody.6e8fddc113d8dc7165be807e490461e6.svg";
export { ForwardRef as ReactComponent };